module.exports = __webpack_public_path__ + "static/media/nobooking.7373f97f.png";